import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {map} from 'rxjs/operators';
import {BrandService} from '../../networking/services/brand/brand.service';
import {countryConfig} from '../../../../country-config/country-config';
import {LocationManager} from '../location/location.manager';
import {CustomerManager} from '../customer/customer/customer.manager';
import {Product} from '../../networking/models/product/responses/product.class';
import {BrowserDetectorService} from '../../networking/services/shared/broswer-detector/browser-detector.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class BrandManager {
  isBrowser;
  constructor(private brandService: BrandService,
              private customerManager: CustomerManager,
              private browserDetectorService: BrowserDetectorService,
              private locationManager: LocationManager,
              @Inject(PLATFORM_ID) platformId,
  ) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
  }

  getBrand(data, screenSize) {
    const defaultTokens = countryConfig.ssrTokens;
    const customer = this.isBrowser ? this.customerManager.customer : null;
    const defCity = countryConfig.defaultCity;
    const defStoreGroup = countryConfig.defaultStoreId;
    data = {
      idStoreGroup: this.isBrowser ? parseInt(this.locationManager.getIdStoreGroup(), 10) : defStoreGroup,
      idCustomerWebSafe: customer?.idCustomerWebSafe || defaultTokens?.idCustomerWebSafe,
      tokenIdWebSafe: customer?.token?.tokenIdWebSafe || defaultTokens?.token?.tokenIdWebSafe,
      token: customer?.token?.token || defaultTokens?.token?.token,
      source: screenSize?.mobile || window.innerWidth < 992 ? 'RESPONSIVE' : 'WEB',
      city: this.isBrowser ? (data.idStoreGroup < 1000 ? (this.locationManager.city?.id || defCity) : '') : defCity,
      ...data,
    };
    const obs = this.brandService.getBrand(data);

    return obs
      .pipe(map(response => {
        const source = response.homeSections;
        const itemList = source.filter(type => type.componentType?.includes('ITEM_LIST_TWO_ROWS'));
        if (itemList) {
          itemList.map(item => {
            const array = [];
            return !item.list ? [] : item.list.map(infoProduct => {
              if (infoProduct.type === 'UNIQUE') {
                infoProduct.product = infoProduct.product?.[0] ? new Product(infoProduct.product[0]) : new Product(infoProduct.product);
                array.push(infoProduct.product);
              }
              if (infoProduct.action === 'SUGGESTED') {
                infoProduct.url = `/sugeridos/${infoProduct.id}`;
                infoProduct = new Product(infoProduct);
                array.push(infoProduct);
              }
              if (infoProduct.action === 'HIGHLIGHTED') {
                infoProduct.url = `/destacados/${infoProduct.id}`;
                infoProduct = new Product(infoProduct);
                array.push(infoProduct);
              }
              item.products = array;
              return infoProduct;
            });
          });
        }

        const count = {
          list: 0,
          banner: 0,
        };
        response.homeSections = response.homeSections.map(c => {
          if (c.componentType === 'ITEM_LIST_TWO_ROWS' && count.list === 0) {
            c.ssr = true;
            count.list++;
          }
          return c;
        });

        return response;
      }));
  }
}
